// @flow
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEqual } from 'lodash';
import { logout } from '@context/user';
import { fetchTeam, selectTeam, selectTeamLoading } from '@context/team';
import { clinicActions } from '@context/clinics';
import { isStoreReview } from '../redux/modules/appVersion';
import { mapBundledPermission, mapManagesClinic } from '@helpers/connect';
import TeamListView from '../components/views/Settings/Team/TeamList';

// Ajustes › Equipe. Loaded again on every visit and after switching clinics: an invite or a removal from another
// device, or the plan's limit, may have changed it. The clinic too: the members' forms read it.
const TeamList = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => get(state, ['context', 'user']));
  const permissions = useSelector(state => mapBundledPermission(state), isEqual);
  const clinicId = useSelector(state => get(state, ['context', 'clinics', 'activeClinic', 'id'], null));
  const team = useSelector(selectTeam);
  const isLoading = useSelector(selectTeamLoading);
  const failed = useSelector(state => Boolean(get(state, ['context', 'team', 'errors'])));
  const isManager = useSelector(mapManagesClinic);
  const storeReview = useSelector(isStoreReview);

  useEffect(() => {
    if (!isManager || !clinicId) return;
    dispatch(fetchTeam());
    dispatch(clinicActions.getClinics());
  }, [dispatch, isManager, clinicId]);

  return (
    <TeamListView
      user={user}
      permissions={permissions}
      onLogout={() => dispatch(logout())}
      team={team}
      isLoading={isLoading}
      failed={failed}
      isManager={isManager}
      storeReview={storeReview}
    />
  );
};

export default TeamList;
